import React, { useContext, useEffect, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import BackEndAPI from '../../Services/BackEndAPI'
import { Button, Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import InputText from '../../DevComponents/InputText'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import ComboBox from '../../DevComponents/ComboBox'
import ClsValidacao from '../../Utils/ClsValidacao'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import { UnidadeOrganizacionalInterface } from '../../ImportBackend/Interfaces/UnidadeOrganizacionalInterfaces'

interface DadosTesteLaisInterface {
  idUnidadeOrganizacional: number
  whatsAPP: string
}

export default function TesteLais() {

  const [dados, setDados] = useState<DadosTesteLaisInterface>({
    idUnidadeOrganizacional: 0,
    whatsAPP: ''
  })

  const [rsUnidadesOrganizacionais, setRsUnidadesOrganizacionais] = useState(Array<UnidadeOrganizacionalInterface>)

  const clsApi = new BackEndAPI()
  const abortController: AbortController = new AbortController()
  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface

  const pesquisarUnidadesOrganizacionaisHabilitadas = () => {

    const query: string = `
      getOULaisHabilitada {
        idUnidadeOrganizacional
        descricao
        laisEnviarTemplateDiaConsulta
        laisEnviarTemplateDiaAnteriorConsulta
      }
    `

    clsApi.query<Array<UnidadeOrganizacionalInterface>>(query, 'getOULaisHabilitada', 'Pesquisando Instâncias de WhatsAPP...', contexto, abortController).then(rs => {

      setRsUnidadesOrganizacionais(rs)

    })

    return () => {

      abortController.abort()

    }

  }

  const navigate = useNavigate()

  useEffect(() => {
    pesquisarUnidadesOrganizacionaisHabilitadas()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [erros, setErros] = useState({})

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.eTelefone('whatsAPP', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('idUnidadeOrganizacional', dados, erros, retorno)

    setErros(erros)

    return retorno

  }

  const enviarTeste = () => {

    if (validarDados()) {
      enviarMensagemDeTestes()
    }

  }

  const { setMensagemState } = contexto

  const enviarMensagemDeTestes = () => {

    const query: string = `
      enviarMensagemLaisTesteOU (idUnidadeOrganizacional: ${dados.idUnidadeOrganizacional}, whatsAPP: "${dados.whatsAPP}") {
        ok
        mensagem
      }
    `

    clsApi.query<RespostaPadraoInterface>(query, 'enviarMensagemLaisTesteOU', 'Enviando Mensagem de Testes...', contexto, abortController).then(rs => {

      if (rs.ok) {

        setMensagemState({
          cb: null,
          exibir: true,
          exibirBotao: true,
          mensagem: 'Testes enviados com sucesso!',
          tipo: MensagemTipo.Info,
          titulo: 'Teste Mensagem da Lais'
        })

        // setDados({ idClinica: 0, whatsAPP: '' })

      } else {

        setMensagemState({
          cb: null,
          exibir: true,
          exibirBotao: true,
          mensagem: rs.mensagem,
          tipo: MensagemTipo.Error,
          titulo: 'Teste Mensagem da Lais'
        })

      }

    })

    return () => {

      abortController.abort()

    }

  }

  return (
    <>

      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Teste Lais
                <Typography variant="body2" gutterBottom>
                  Teste de Envio de Templates via Lais API para o WhatsAPP
                </Typography>
              </Typography>

              <IconButton onClick={() => navigate('/')}>
                <CloseIcon />
              </IconButton>
            </Grid>


            <Grid item xs={12} md={6}>
              <ComboBox
                campoDescricao='descricao'
                campoID='idUnidadeOrganizacional'
                opcoes={rsUnidadesOrganizacionais}
                dados={dados}
                field='idUnidadeOrganizacional'
                label='Unidade Organizacional'
                mensagemPadraoCampoEmBranco='Escolha a Unidade Organizacional'
                erros={erros}
                valorPadraoCampoEmBranco={0}
                setState={setDados}
              />
            </Grid>

            <Grid item xs={12} md={4} sx={{ pl: { md: 1 } }}>
              <InputText
                dados={dados}
                field='whatsAPP'
                label='WhatsAPP para Envio do teste'
                erros={erros}
                setState={setDados}
                mask='tel'
              />
            </Grid>

            <Grid item xs={12} md={2} sx={{ mt: 4.5, pl: { md: 1 } }}>
              <Button variant='contained' onClick={() => enviarTeste()}>Enviar</Button>
            </Grid>

          </Grid>
        </Paper>
      </Container>

    </>
  )

}